"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _base = _interopRequireDefault(require("./base"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The Revit upgrade service, is used to fetch project related data.
 */
var RevitUpgradeService = /*#__PURE__*/function (_Base) {
  /**
   * Create the revit upgrade service instance.
   *
   * @param sdk - the SDK instance
   */
  function RevitUpgradeService(sdk) {
    (0, _classCallCheck2["default"])(this, RevitUpgradeService);
    return _callSuper(this, RevitUpgradeService, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(RevitUpgradeService, _Base);
  return (0, _createClass2["default"])(RevitUpgradeService, [{
    key: "postQuery",
    value: (
    /**
     * Create a new query for a project's metadata
     * https://git.autodesk.com/revit/UpgradeService/blob/master/docs/swagger.yaml#L109
     * @param hubId -, the hub id, equals to "b.[ACCOUNT_ID]"
     * @param projectId - , the project id
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with list of creating query job result, shape of \{'projectId', 'queryId', 'status'\}
     */
    function () {
      var _postQuery = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(hubId, projectId, config) {
        var payload, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              payload = {
                hubId: hubId,
                projectId: projectId
              };
              _context.next = 3;
              return this.HttpService.rvtUpgradeV1.postWithRetry("/queries", payload, config);
            case 3:
              response = _context.sent;
              return _context.abrupt("return", response.data);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function postQuery(_x, _x2, _x3) {
        return _postQuery.apply(this, arguments);
      }
      return postQuery;
    }()
    /**
     * Get the query result on a project metadata
     * https://git.autodesk.com/revit/UpgradeService/blob/master/docs/swagger.yaml#L144
     * @param queryId -, metadata query id
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with list of creating query job result, shape of \{'projectId', 'queryId', 'status', \{ JobDetail\}\}
     */
    )
  }, {
    key: "getQuery",
    value: (function () {
      var _getQuery = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(queryId, config) {
        var response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.HttpService.rvtUpgradeV1.get("/queries/".concat(queryId), config);
            case 2:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getQuery(_x4, _x5) {
        return _getQuery.apply(this, arguments);
      }
      return getQuery;
    }()
    /**
     * Create a new upgrade job for an ACC project
     * https://git.autodesk.com/revit/UpgradeService/blob/master/docs/swagger.yaml#L70
     * @param hubId -, the hub id, equals to "b.[ACCOUNT_ID]"
     * @param projectId - , the project id
     * @param targetVersion -, Revit release version to upgrade
     * @param optionalPayload -, job optional body. testUpgrade: Specific whether this job is intend to be a test upgrade job
     *   \{
     *     testUpgrade
     *   \}
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with list of creating query job result, shape of \{'projectId', 'jobId', 'status', 'targetVersion', 'userId'\}
     */
    )
  }, {
    key: "postUpgrade",
    value: (function () {
      var _postUpgrade = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(hubId, projectId, targetVersion, optionalPayload, config) {
        var payload, response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              payload = {
                hubId: hubId,
                projectId: projectId,
                targetVersion: targetVersion
              };
              _context3.next = 3;
              return this.HttpService.rvtUpgradeV1.postWithRetry("/jobs", (0, _extends2["default"])({}, payload, optionalPayload), config);
            case 3:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function postUpgrade(_x6, _x7, _x8, _x9, _x10) {
        return _postUpgrade.apply(this, arguments);
      }
      return postUpgrade;
    }()
    /**
     * Get the status of a submitted Job
     * https://git.autodesk.com/revit/UpgradeService/blob/master/docs/swagger.yaml#L35
     * @param upgradeId -, upgrade job id
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with list of creating query job result, shape of \{'projectId', 'jobId', 'status', \{ JobDetail\}\}
     */
    )
  }, {
    key: "getUpgrade",
    value: (function () {
      var _getUpgrade = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(upgradeId, config) {
        var response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.HttpService.rvtUpgradeV1.get("/jobs/".concat(upgradeId), config);
            case 2:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getUpgrade(_x11, _x12) {
        return _getUpgrade.apply(this, arguments);
      }
      return getUpgrade;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'RevitUpgradeService';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = RevitUpgradeService;